import React from "react"
import { useApiIsLoaded } from "@vis.gl/react-google-maps"
import { useMapBBox } from "../components/providers/MapBBoxProvider"

const GMapsApiLoadChecker: React.FC = () => {
  const { setGMapsApiLoaded } = useMapBBox()
  const apiIsLoaded = useApiIsLoaded()
  React.useEffect(() => setGMapsApiLoaded(apiIsLoaded), [apiIsLoaded, setGMapsApiLoaded])
  return null
}

export default GMapsApiLoadChecker
